import { createContext, useContext } from "react";

const RoleContext = createContext();

export const RoleProvider = ({ userRole, children }) => {
  return (
    <RoleContext.Provider value={{ role: userRole }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => useContext(RoleContext);
